import { useFormikContext } from 'formik';
import { TextInput } from '../ui/TextInput';
import { ErrorMessage } from './ErrorMessage';
import type { InputHTMLAttributes } from 'react';

interface FormFieldProps extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
  icon?: string;
}

export function FormField({ name, icon, ...otherProps }: FormFieldProps) {
  const { setFieldTouched, setFieldValue, values, errors, touched } = useFormikContext<Record<string, string>>();

  const error = touched[name] && errors[name] ? String(errors[name]) : undefined;

  return (
    <div>
      <TextInput
        icon={icon}
        onBlur={() => setFieldTouched(name)}
        onChange={(e) => setFieldValue(name, e.target.value)}
        value={values[name] || ''}
        {...otherProps}
      />
      <ErrorMessage error={error} visible={!!error} />
    </div>
  );
}

export default FormField;
